<template>
	<div class="card-row-block">
		<router-link class="card-block-link" v-if="routeName" :to="{ name: routeName, params: { id: id } }"></router-link>
		<div class="card-row-content">
			<div class="card-row-sep">
				<span class="eyebrow">Happiness Index Report</span>
				<h3>{{ title }}</h3>
			</div>
			<div class="score-card-total">
				<span class="score-card-result">{{ score }}</span>
				<span class="score-card-total-max">/ 10</span>
			</div>
		</div>
		<div class="card-row-icon">
			<ChartIcon style="width: 30px;" />
		</div>
	</div><!-- card -->
</template>

<script>
import ChartIcon from '@/assets/chart.svg';
export default {
	name: 'ReportRow',
	props: {
		title: String,
		text: String,
		type: String,
		routeName: String,
		score: Number,
        id: Number
	},
	components: {
		ChartIcon
	}
};
</script>

<style scoped lang="scss">
	@import "@/assets/scss/_variables.scss";
	.card-row-block {
		position: relative;
		padding: 17px;
		border-radius: 12px;
		border: 1px solid $snow;
		display: flex;
		justify-content: space-between;
		border: 1px solid transparent;
		background: $snow;
		align-items: center;
		margin-bottom: 14px;
		&:last-of-type {
			margin-bottom: 0;
		}
		&.card-row-block-resources {
			background: $white;
			border-color: $snow;
			box-shadow: 5px 15px 15px 5px $snow;
			.card-row-content {
				h3 {
					color: $dark;
				}
			}
			.card-row-icon {
				svg g, svg path {
					stroke: $sky_base;
				}
				svg .fill {
					fill: $sky_base;
					stroke: none;
				}
			}
		}
		.card-block-link {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 1;
		}
		&.card-row-block-alt {
			width: 295px;
			margin-right: 12px;
			flex-shrink: 0;
			min-height: 200px;
			align-items: flex-start;
			margin-bottom: 0;
			box-shadow: none;
			padding-bottom: 50px;
			&.full {
				width: 100%;
				background: $white;
				border-color: $snow;
				box-shadow: 5px 15px 15px 5px $snow;
			}
			.card-row-content {
				p {
					color: $mid;
				}
				.card-tag {
					position: absolute;
					bottom: 17px;
					left: 17px;
				}
			}
			&:last-of-type {
				margin-right: 0;
			}
		}
		&.card-row-block-report {
			padding-bottom: 17px;
			min-height: 150px;
		}
	}
	.card-row-content {
		text-align: left;
		width: 100%;
		padding-right: 20px;
		height: 100%;
	    display: flex;
	    flex-direction: column;
	    justify-content: space-between;
		.card-tag {
			display: flex;
			align-items: center;
			.tag-icon {
			    width: 16px;
				overflow: visible;
				margin-right: 5px;
				.line {
					stroke: $mid;
					stroke-width: 5;
				}
				.dot {
					fill: $mid;
				}
			}
			span {
				font-size: 13px;
				line-height: 16px;
				font-weight: $weight_600;
				color: $mid;
			}
		}
		.eyebrow {
			text-transform: uppercase;
			font-size: 10px;
			opacity: 0.8;
			letter-spacing: 0.83px;
			line-height: 12px;
			color: $slate;
			display: block;
			font-weight: $weight_500;
			margin-bottom: 5px;
		}
		h3 {
			font-size: 17px;
			letter-spacing: -0.5px;
			line-height: 20px;
			color: $slate;
			font-weight: $weight_600;
			margin-bottom: 5px;
		}
		p {
			opacity: 0.9;
			font-size: 14px;
			line-height: 19px;
			color: $slate;
			font-weight: $weight_400;
		}
	}
	.score-card-total {
		font-weight: 600;
		color: $sky_base;
		font-size: 40px;
		letter-spacing: -1.18px;
		line-height: 24px;
		.score-card-total-max {
			font-size: 26px;
			letter-spacing: -0.76px;
			opacity: 0.7;
			margin-left: 10px;
		}
	}
	.card-row-icon {
		flex-shrink: 0;
		svg {
			display: block;
		}
	}
</style>
